import React from "react"

import Flex from "@irati/ui/src/Flex"
import Form from "@irati/ui/src/Form"
import {Checkbox} from "@irati/ui/src/FormItem"
import FormattedMessage from "@irati/utils/lang"

interface Props {
  checkEsd: boolean
  checkDob: boolean
  onEsdChange: () => void
  onDobChange: () => void
}

const FilterEsdAndDob: React.FC<Props> = ({checkEsd, checkDob, onEsdChange, onDobChange}) => {
  return (
    <Form>
      <Flex marginTop gap={2}>
        <Checkbox name="filter__esd" checked={checkEsd} onChange={onEsdChange}>
          <FormattedMessage id="admin.components.filterEsdAndDob.esd.label" />
        </Checkbox>
        <Checkbox name="filter__dob" checked={checkDob} onChange={onDobChange}>
          <FormattedMessage id="admin.components.filterEsdAndDob.dob.label" />
        </Checkbox>
      </Flex>
    </Form>
  )
}

export default FilterEsdAndDob
